<script lang="ts" setup>
	import {useFilters} from '@/store/filter.store';

	defineProps<{
		loading: boolean;
		numberOfProducts: number;
	}>();

	const emit = defineEmits(['reset-filters']);

	const resetFilters = () => {
		useFilters().resetFilters();
		emit('reset-filters');
	};
</script>

<template>
	<div v-if="loading">
		<div class="table-loading-placeholder">
			<div class="table-loading-placeholder_loader">
				<span></span>
				<span></span>
				<span></span>
			</div>
			<transition name="table-loading">
				<p v-show="$t('generic.error.message')" class="table-loading-placeholder_message"></p>
			</transition>
		</div>
	</div>

	<div v-if="!loading && numberOfProducts === 0" class="catalog-overview-message show">
		<h3>{{ $t('site.products.overview.noresults.title') }}</h3>
		<p>
			<span v-html="$t('site.products.overview.noresults.message.paragraph1.text')"></span>
			<span>&nbsp;</span>
			<a href="#"
			   @click.prevent="resetFilters">
				{{ $t('site.products.overview.noresults.message.link.text') }}
			</a>
		</p>
	</div>
</template>
